import { isMarketingConsentGranted } from './marketingConsent';

const META_PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || '').trim();
const META_PIXEL_SCRIPT_URL = 'https://connect.facebook.net/en_US/fbevents.js';
const META_PIXEL_SCRIPT_SELECTOR = 'script[data-beestmode-meta-pixel="true"]';
const META_LANDING_EVENT = 'BeestmodeLandingView';

let initializedPixelId = '';
let metaConsentWasRevoked = false;
const trackedLandingViews = new Set();

const isValidPixelId = (pixelId) => /^\d{5,32}$/.test(pixelId);

const installFbq = () => {
  if (window.fbq) return window.fbq;

  const fbq = function metaPixelQueue() {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, arguments);
    } else {
      fbq.queue.push(arguments);
    }
  };

  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  return fbq;
};

export const initializeMetaPixel = () => {
  if (
    typeof window === 'undefined'
    || typeof document === 'undefined'
    || !isValidPixelId(META_PIXEL_ID)
    || !isMarketingConsentGranted()
  ) {
    return false;
  }

  const fbq = installFbq();

  if (!document.head.querySelector(META_PIXEL_SCRIPT_SELECTOR)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = META_PIXEL_SCRIPT_URL;
    script.dataset.beestmodeMetaPixel = 'true';
    document.head.appendChild(script);
  }

  if (initializedPixelId !== META_PIXEL_ID) {
    fbq('init', META_PIXEL_ID);
    initializedPixelId = META_PIXEL_ID;
  }

  if (metaConsentWasRevoked) {
    fbq('consent', 'grant');
    metaConsentWasRevoked = false;
  }

  return true;
};

const deleteMetaCookie = (cookieName) => {
  document.cookie = `${cookieName}=; Max-Age=0; Path=/; SameSite=Lax`;
};

export const revokeMetaPixelConsent = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  if (typeof window.fbq === 'function') {
    window.fbq('consent', 'revoke');
    metaConsentWasRevoked = true;
  }

  document.head.querySelector(META_PIXEL_SCRIPT_SELECTOR)?.remove();
  deleteMetaCookie('_fbp');
  deleteMetaCookie('_fbc');
  trackedLandingViews.clear();
};

export const trackMetaLandingView = ({
  pageKey,
  bannerCode,
  requestedBannerCode,
  isKnownBannerCode,
  detectedPlatform,
}) => {
  if (!initializeMetaPixel() || trackedLandingViews.has(pageKey)) return false;

  trackedLandingViews.add(pageKey);
  window.fbq('track', 'PageView');
  window.fbq('trackCustom', META_LANDING_EVENT, {
    banner_code: bannerCode,
    requested_banner_code: requestedBannerCode || '',
    is_known_banner_code: Boolean(isKnownBannerCode),
    detected_platform: detectedPlatform,
  });

  return true;
};

export { META_LANDING_EVENT };
